import { generateRequest } from '.';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Brands: {
    FeatBrandsPending: 'FeatBrands_PENDING',
    FeatBrandsCompleted: 'FeatBrands_FULFILLED',
    FeatBrandsFailed: 'FeatBrands_FAILED',
    BrandsPending: 'Brands_PENDING',
    BrandsCompleted: 'Brands_FULFILLED',
    BrandsFailed: 'Brands_FAILED',
  },
};

export const fetchBrands = (brandIds = []) => generateRequest({
  endpoint: `/assets-v2/api/brands${brandIds.length ? `?${toQueryString({ brandIds })}` : ''}`,
  types: [
    Action.Brands.BrandsPending,
    Action.Brands.BrandsCompleted,
    Action.Brands.BrandsFailed,
  ],
});

export const fetchFeaturedBrands = () => generateRequest({
  endpoint: '/assets-v2/api/brands/featured',
  types: [
    Action.Brands.FeatBrandsPending,
    Action.Brands.FeatBrandsCompleted,
    Action.Brands.FeatBrandsFailed,
  ],
});
